module.exports = __webpack_public_path__ + "media/images/projects/17-dashboard-d55a7a8c7048690a66ca83700e4c8cbb.jpg";